import { gql } from 'apollo-boost'
// import { Mutation } from 'react-apollo'

export const getCompanies = gql`
  {
    companies {
      name
      id
      country
      short
      description
    }
  }
`
export const addCompany = gql`
  mutation addCompany($name: String!, $description: String) {
    addCompany(name: $name, description: $description) {
      name
      id
    }
  }
`
export const updateCompany = gql`
  mutation($id: String!, $name: String, $description: String) {
    updateCompany(id: $id, name: $name, description: $description) {
      name
      id
    }
  }
`
